import React from 'react';
import { socialLinks } from '../data/portfolioData';
import Icon from './Icon';
import useScrollReveal from '../hooks/useScrollReveal';
import './Contact.css';

const Contact: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="contact" className="section contact" ref={ref}>
      <div className={`container ${isVisible ? 'revealed' : 'hidden-section'}`}>
        <h2 className="section-title">Contattami</h2>
        <p className="section-subtitle">
          Hai un progetto in mente? Parliamone!
        </p>

        <div className="contact-wrapper">
          <div className="contact-info animate-fade-in-up">
            <h3>Restiamo in contatto</h3>
            <p>
              Sono sempre aperto a nuove opportunità e collaborazioni interessanti.
              Non esitare a contattarmi!
            </p>

            <div className="contact-channels">
              {socialLinks.map(link => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-channel"
                >
                  <div className="contact-channel-icon">
                    <Icon icon={link.icon} />
                  </div>
                  <div className="contact-channel-info">
                    <div className="label">{link.name}</div>
                    <div className="value">
                      {link.url.replace('mailto:', '').replace('https://', '')}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
